export default function () {
	const html = document.documentElement;
	const { body } = document;

	html.classList.remove('no-js');
	html.classList.add('js');

}
